<template>
  <div
    class="notification-widget"
    :class="{
      'notification-widget--adaptive': isLessThanSM,
      'notification-widget--adaptive-with-player': isPlayerOpenAdaptive
    }"
  >
    <transition name="animation-fade-up">
      <NotificationsPopup v-if="isOpen" class="notification-widget__dropdown"/>
    </transition>
  </div>
</template>

<script setup>
import {watch, onMounted} from 'vue';
import {useStore} from 'vuex';
import {useUserAuth} from '@/Groups/Notifications/private/imports/userStoreData';
import {useNotificationsDropdown} from '@/Groups/Notifications/private/imports/toggleDropdown';
import {useScreenSize} from "@shared/composables/screenWidth/useScreenSize";
import { usePlayerStates } from '@/Groups/Notifications/private/imports/audioplayerStates';
//---------------------------------
import NotificationsPopup from '@/Groups/Notifications/private/core/NotificationsPopup/NotificationsPopup.vue';
//---------------------------------
const store = useStore();
//---------------------------------
const {isLessThanSM} = useScreenSize();
//---------------------------------
const {isPlayerOpenAdaptive} = usePlayerStates();
//---------------------------------
const {hasPaidAccount} = useUserAuth();
//---------------------------------
const {isOpen} = useNotificationsDropdown();
//---------------------------------
onMounted(async () => {
  if (!hasPaidAccount.value) return;
  await checkNewNotifications();
})
//---------------------------------
//Проверить наличие новых уведомлений при отрисовке
const checkNewNotifications = async () => {
  await store.dispatch('Notifications/checkNewNotifications');
}
//---------------------------------
//Отслеживание изменений hasPaidAccount
watch(hasPaidAccount, (newValue) => {
  if (newValue) {
    checkNewNotifications();
  }
}, {immediate: true});
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
